<template>
  <div class="grade-talbe">
    <div
      class="grade-analysis"
      :class="`${type} ${size}`"
    >
      <div class="left-info">
        <div>{{ tableDetail.leftTitle }}</div>
      </div>
      <table class="right-table">
        <tr class="table-header">
          <th v-for="(tt,tindex) in tableHeader" :key="tindex" class="top-header">{{ tt }}</th>
        </tr>
        <tr v-for="(v,idx) in tableDetail.children" :key="idx" class="table-content">
          <td class="pro-name">{{ v.parName }}</td>
          <td class="pro-details" :class="{'no-border': idx === tableDetail.children.length - 1}">
            <div class="number">{{ v.name1 }}</div>
            <div class="line" />
          </td>
          <td class="pro-details" :class="{'no-border': idx === tableDetail.children.length - 1}">
            <div class="number">{{ v.name2 }}</div>
            <div class="line" />
          </td>
          <td class="pro-details" :class="{'no-border': idx === tableDetail.children.length - 1}">
            <div class="line" />
            <div class="number">{{ v.name3 }}</div>
          </td>
          <td class="pro-details" :class="{'no-border': idx === tableDetail.children.length - 1}">
            <div class="line" />
            <div class="number">{{ v.name4 }}</div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableHeader: {
      type: Array,
      default: () => []
    },
    tableDetail: {
      type: Object,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import "../_pages/index.scss";

// default
.no-border {
  border: none !important;
}

.grade-talbe {
  font-family: MyFont;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .grade-analysis {
    width: 370px;
    display: flex;
    justify-content: space-between;

    .left-info {
      width: 77px;
      font-size: 21px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px dashed #00B66C;

      div {
        display: flex;
        width: 20px;
      }
    }

    .right-table {
      width: 280px;
      height: 256px;
      border: 1px solid #00B66C;
      border-collapse: collapse;
      text-align: center;

      tr {
        background: none !important;
      }

      .table-header {
        .top-header {
          height: 44px;
          text-align: center;
          color: #666666;
          font-weight: 500;
          border-bottom: 1px solid #00B66C;
          font-size: 12px;

          &:nth-child(1) {
            border-right: 1px solid #00B66C;
            width: 60px;
          }

          &:nth-last-child(1) {
            color: #333;
            font-weight: 500;
          }
        }
      }

      .table-content {
        &:nth-last-child(1) {
          border-bottom: 0px;
        }

        .pro-name {
          width: 60px;
          text-align: center;
          font-size: 13px;
          font-weight: 500;
          color: #00B66C;
          border-right: 1px solid #00B66C;
          border-bottom: none;
        }

        .pro-details {
          border-bottom: 1px solid #BFDBCF;
          text-align: center;
          font-size: 24px;
          color: #00B66C;
          font-weight: bold;
          position: relative;

          .line {
            width: 1px;
            height: 13px;
            background: rgba($color: #333, $alpha: .23);
            position: absolute;
            top: 50%;
            right: 0;
            margin-top: -7px;
          }

          &:nth-last-child(1) {
            border-right: 0;
            color: #754FFF;
            font-size: 26px;
            font-weight: bold;

            .line {
              width: 0px;
            }
          }
        }
      }
    }
  }
  // mid版
  .mid{
     .right-table {
       height: 150px;
     }
    //  .pro-details{
    //    font-size: 20px!important;
    //  }
  }
  // small版
  .small {
    .left-info {
      div {
        width: 15px;
      }
      font-size: 15px;
    }

    .right-table {
      height: 140px;
      .table-header {
        .top-header {
          height: 28px;
        }
      }

      .table-content {
        .pro-name {
          height: 28px;
        }

        .pro-details {
          font-size: 15px;
          border: none;

          &:nth-last-child(1) {
            font-size: 15px;
          }
        }
      }
    }
  }

  //橘色系
  .orange {
    .left-info {
      border: 1px dashed #FB834D;
      background: #FB834D;
      color: white;
    }

    .right-table {
      border: 1px solid #FB834D;

      .table-header {
        .top-header {
          border-bottom: 1px solid #FB834D;

          &:nth-child(1) {
            background: #FB834D;
            color: white;
            border-right: 1px solid #FB834D;
          }
        }
      }

      .table-content {
        border-bottom: 1px solid #FB834D;

        .pro-name {
          background: #FB834D;
          color: white;
          border-right: 1px solid #FB834D;
        }
      }
    }
  }
}
</style>
